import * as Yup from "yup";
import ConstituencyModel from "../../models/masters/constituency-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetDistrict } from "../../apiclient/master/useGetDistrictApi";
import { SelectField } from "../../core/select-field.component";
import { useGetConstituency } from "../../apiclient/master/useGetConstituencyApi";

interface ConstituencyEditProps {
  data: ConstituencyModel;
  isViewMode?: boolean;
  onClose?: (status: SubmitStatus, data: any) => any;
}

const ConstituencyEntry: React.FC<ConstituencyEditProps> = ({ ...props }) => {
  let { data,  onClose,isViewMode } = props;
  const title = data?.constituencyId > 0 ? "Edit Constituency" : "Add Constituency";
  
  let initialValue: ConstituencyModel = {
    constituencyId: data?.constituencyId ? data.constituencyId : 0,
    name: data?.name,
    districtId: data?.districtId ? data.districtId : 0,
    districtName: data?.districtName,

   
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "Constituency name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 
  
  });
  console.log(initialValue)


  const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
  const { data: fetchedConstituency } = useGetConstituency();
  
  const [districtData, setDistrictData] = useState<{ value: string; label: string }[]>([]);
  const { data: fetchedDistrict } = useGetDistrict();

  useEffect(() => {
    if (fetchedConstituency) {
      setExistingName(fetchedConstituency.map((con: any) => con.name)); // Extracting zone names to compare against
  }

      if (fetchedDistrict) {
          const mappedDistrict = fetchedDistrict.map((district: any) => ({
              value: district.districtId.toString(),
              label: district.name,
          }));
          setDistrictData(mappedDistrict);
      }
  }, [fetchedDistrict]);

  
  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="Constituency/SaveConsituency"
        showAddAnother={true}
        isUpDateEntityDetails={data?.constituencyId>0? true: false}
        isViewOnly ={isViewMode}

      > 
        <div>
          <div className="row">
            <div className="col-6">
              <InputField maxLength={10} label="Constituency *" name="name" />
            </div>
            <div className="col-6">
            <SelectField
                                label="District"
                                name="districtId"
                                options={districtData}
                                unSelectValue={0}
                            />       
                                 </div>
                      
                
              
            </div>
          </div>
        
      </FormikModelDialog>
    </>
  );
};

export default ConstituencyEntry;
